import { INavigationConfigurationInterface } from '@ispm/navigation/interfaces';

export const NavigationInitState: INavigationConfigurationInterface = {
  navigation: null,
  currentSelected: null,
  isAppConfigEnabled: false,
  init: false
};
